import { render, staticRenderFns } from "./SelectSaleModal.vue?vue&type=template&id=289bac36&"
import script from "./SelectSaleModal.vue?vue&type=script&lang=js&"
export * from "./SelectSaleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports